import * as React from 'react';
import { IBuilder } from '../../types/newbuilding';
import * as styles from './AloneBuilder.css';
import { ActionLink, Avatar, UIHeading4 } from '@cian/ui-kit';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import { NoSsr } from '@cian/react-utils';

export interface IAloneBuilderProps {
  builder: IBuilder;
  onBuilderClick?: () => void;
  isPromoSnippet?: boolean;
}

export function AloneBuilder({ builder, onBuilderClick, isPromoSnippet = false }: IAloneBuilderProps) {
  return (
    <a
      data-mark="AloneBuilder"
      data-testid="AloneBuilder"
      className={clsx(styles['container'], { [styles['container--promo']]: isPromoSnippet })}
      href={builder.url}
      target="_blank"
      rel="noreferrer"
      onClick={onBuilderClick}
    >
      {/*
        Логотип монтируем только на клиенте: в SSR он даёт <img>, для которого React 19 выносит preload
        в <head>, и десятки некешируемых логотипов конкурируют с LCP-картинкой за канал.
        Место под логотип зарезервировано контейнером .avatar, сдвига разметки нет.
      */}
      {builder.logoUrl && (
        <div className={styles['avatar']} data-testid="AloneBuilderLogo">
          <NoSsr defer>
            <Avatar src={builder.logoUrl} size={64} type="builder" hideBorder />
          </NoSsr>
        </div>
      )}
      <div className={clsx({ [styles['name-block']]: isPromoSnippet })}>
        <div className={clsx(styles['name'], { [styles['name--without-logo']]: !builder.logoUrl })}>
          <UIHeading4 as="span" color="current_color">
            {builder.name}
          </UIHeading4>
        </div>
        <div className={styles['link']}>
          <ActionLink
            fontSize="M"
            fontWeight="bold"
            color="current_color"
            afterIcon={<IconActionChevronRightSmall16 color="current_color" />}
          >
            О застройщике
          </ActionLink>
        </div>
      </div>
    </a>
  );
}
